import loopWidget from './loop-widget.js';
import loopWidgetCms from './loop-widget-cms.js';

function index() {
  loopWidget();
  loopWidgetCms();
}

export default index;
